import {Inject,Injectable,Injector} from "@angular/core";
import {WebsocketProgressHandler} from "./websocket-progress-handler";
import {PollingProgressHandler} from "./polling-progress-handler";
import {environment} from "@environments/environment";
import {DEFAULT_PROGRESS_HANDLER_TYPE,TypeHandler} from "./progress-handler.config";
import {AbstractProgressHandler} from "./abstract-progress-handler";

/**
 * Factory pour la création d'un handler du suivi de l'avancement d'un traitement back
 *
 * @author Laurent Convert
 * @date 08/08/2025
 */
@Injectable({
	providedIn: 'root'
})
export class ProgressHandlerFactory {
	/**
	 * Constructeur
	 *
	 * @param injector Injecteur Angular
	 * @param typeHandler Type d'implémentation du handler
	 */
	constructor(private injector: Injector,
				@Inject(DEFAULT_PROGRESS_HANDLER_TYPE) private typeHandler: TypeHandler) {
	}

	/**
	 * Création du handler dont l'implémentation correspond soit au type passé en paramètre, soit au type paramétré globalement
	 *
	 * @param typeHandler Type d'implémentation du handler. Si omis le type configuré globalement sera utilisé
	 */
	createHandler(typeHandler?: TypeHandler): AbstractProgressHandler {
		//Utilisation du type de handler fournit ou celui par défaut
		typeHandler = typeHandler ?? this.typeHandler;

		//Retourne l'implémentation correspondante au type
		switch (typeHandler) {
			case TypeHandler.WEBSOCKET:
				//Implémentation de type websocket
				return new WebsocketProgressHandler({type: typeHandler,destination: `/user/progression`},this.injector);
			case TypeHandler.POLLING:
				//Implémentation de type polling HTTP
				return new PollingProgressHandler({type: typeHandler,url: `${environment.baseUrl}/controller/Progression/checkProgression`},this.injector);
		}
	}
}

/** Configuration d'un handler avec une connexion de type Websocket */
export type WebsocketProgressHandlerOptions = {destination: string};
export type WebsocketProgressHandlerConfig = {type: TypeHandler.WEBSOCKET } & WebsocketProgressHandlerOptions;
export const websocketProgressHandlerDefaultConfig: Partial<PollingProgressHandlerConfig> = {};

/** Configuration d'un handler avec une connexion de type Polling */
export type PollingProgressHandlerOptions = {url: string,intervalMs?: number};
export type PollingProgressHandlerConfig = {type: TypeHandler.POLLING } & PollingProgressHandlerOptions;
export const pollingProgressHandlerDefaultConfig: Partial<PollingProgressHandlerConfig> = {intervalMs: 5000};
